import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'normalize.css'
import './assets/css/index.less'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// import { vLoading } from 'element-plus/es/components/loading/src/directive'
import { globalRegister } from './global'

import '@/assets/iconfont/iconfont.js'

// import { createPinia } from 'pinia'
import './permission'
import store from '@/store'
import { debounce } from 'lodash-es'
import i18n from '@/lang'

import JsonViewer from 'vue-json-viewer'

const app = createApp(App)
// const pinia = createPinia()
app.use(ElementPlus)
// app.directive('load', vLoading)
app.use(globalRegister)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// app.component('WarnFilled', ElementPlusIconsVue.WarnFilled)

// app.use(pinia)
app.use(store)
app.use(router)
app.use(JsonViewer)
// app.mount('#app')
app.use(i18n)

router.isReady().then(() => {
  app.mount('#app')
})

// element-plus 报错：ResizeObserver loop limit exceeded  elementplus 问题
const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback: any) {
    callback = debounce(callback, 16)
    super(callback)
  }
}
